// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2021-11-18T15:56:07+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  144114
//    Project:        349
//    Environment:    794 - master
//    MD5:            d57d0490c2bba9ad1c64d69a1017b320
//    Signature:      eyJpdiI6Ik1jQnl1YzZJQXc5TzlVSVZ2VjhIZkE9PSIsInZhbHVlIjoiOUxCaCtGZ09qc2F4ekRENXNUZ0ZvdmdpSG8zbmFWaVB2VVd5ZTByM0tUSHIyOG1xa1ZNTmRoNXNvUEZFSVwvTW9zcGliaHU3WFZRcmdwY2RPOThGOFR1elNCZVwvUWlCSmJSbGR3ck1YSStGQXk4K0RINUJMNGIxTVwvYzRyQWNjVFdvMmJWTzRHSlI4ZDFtbVA2QnNjZ1wvenoxeFJyNnNTY3RhWEJHVVVEQzcxTjBkZlZCS25WamtKOGEyR2t2YkthdFMxMllPaVo4dEdQTnBOYzhPR2lPRDB4aitNXC9CQ0dqajJcL3BRaGg4bDZiWmVcL1ZJd3MxeUVkYjczTjJEdmhDaVQzR1ZoXC80QTBOblF4WXJFa1FSNVg0eXVuQnQrQWQ5ZnhmV1pqREFOd2d4MWJab0lISm5cL3E0THh3YitXV1gzcWhaVk5LMnNySDJkMlpYUjRieVJRdzljZ0xOWFQ5ZlhMUjNiRzA5WDBaTzBzUjQxUmdsbVwvZk1pS3BUK2N1bE50SUloa2V2ZVc0VzRFcjhMVWJRY1hZV1VOUnV3RGtSWGRMNnJhcWtVc3ZrZm89IiwibWFjIjoiZWU4YWZjM2JlMDk4ZjFhYTkzM2EzMDg1ZGNjYjA3OTQ0ZWZlYTQ1OTE2NWU5OWVjOWQ5Mzk4NDRhMzg0ZGZjOCJ9
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
})();